import * as React from 'react';
import {Card,Avatar, Typography,Box} from  "@material-ui/core";
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import List from '@mui/material/List';




import useStyles from './style';
import {useSelector} from 'react-redux'


export const Userlist=()=> {
  const cls=useStyles();
  const users=useSelector((state)=>state.Userlist)
  console.log(users.data)


  return (
    <div>
    <Typography className={cls.head}>Users</Typography>
      {users?.data?.map(users=>(
        <Box  flex={2} p={2}  sx={{ display:{ xs:"none",sm:'block'}}}>

        <List  sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        <ListItem key={users._id} alignItems="flex-start">
          <ListItemAvatar>
            <Avatar alt={users.name} src={users.Profilepic} />
          </ListItemAvatar>
          <ListItemText
            primary={users.email}
            secondary={
              <React.Fragment>
                <Typography
                  sx={{ display: 'inline' }}
                  component="span"
                  variant="body2"
                  color="primary"
                >
                 {users.name}
                </Typography>
                {" — I'll be in your neighborhood doing errands this…"}
              </React.Fragment>
            }
          />
        </ListItem>
        <Divider variant="inset" component="li" />
      </List>
       
      </Box>
    ))}
  </div>
  );
}
